




























































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { UnitSafetyCheckData, emptyData, getInfo, postData, putData } from '@/api/heritageUnit/unitSafetyCheck'
import { getLookupByType, DDLItem } from '@/api/common/select'
import { enFirstType, enLookupType } from '@/configs/enums'
import { validateIntKey, showVaildMsg } from '@/configs/validate'
import { getDDLItem, toDefaultInt } from '@/configs/functions'
import Element from 'element-ui'
import { UploadOptData } from '@/api/common/upload'
import { AttachInfo } from '@/api/common/attach'
import hspGallery from '@/components/upload/gallery.vue'
import FormDialog from '@/components/dialog/formDialog.vue'

const getFormRules = (form: { [key: string]: string }) => {
  return {
    CheckUnitName: [{ required: true, message: '请输入检查单位名称', trigger: 'blur' }],
    ExaminedUnit: [{ required: true, message: '请输入受检查单位名称', trigger: 'blur' }],
    CheckDate: [{ required: true, message: '请选择巡查时间', trigger: 'blur' }],
    RiskLevel: [{ required: true, validator: validateIntKey('请选择风险等级'), trigger: 'blur' }]
  }
}
@Component({
  components: { FormDialog, hspGallery }
})
export default class UnitSafetyCheckForm extends Vue {
  public name = 'UnitSafetyCheckForm'
  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void
  public showDialog: boolean = false

  public expandNames: string[] = ['base', 'safeCase']
  public loading: boolean = false
  public implementIndex: number = -1
  public riskLevelList: DDLItem[] = []
  public form: UnitSafetyCheckData = Object.assign({}, emptyData)
  public rules = getFormRules(this.form)
  public $refs!: {
    formData: Element.Form
    gyPhoto: hspGallery
  }
  public hasVirusPhoto: boolean = false
  public onGalleryChange(data: { opts: UploadOptData, files: AttachInfo[] }) {
    const list = data.files
    this.hasVirusPhoto = list && list.length > 0
  }
  public created() {
  }
  public fetchSource() {
    const firstType = enFirstType.Select
    if (this.riskLevelList.length === 0) {
      getLookupByType(enLookupType.SafetyCheckRiskLevel, firstType).then((response: { data: any }) => {
        const data = response.data
        if (data) {
          this.riskLevelList = data
        }
      })
    }
  }
  public mounted() {
    window.eventBus.$on("openUnitSafetyCheckForm", (info: { unitId: number, dataId: number }) => {
      this.fetchSource()
      this.fetchData(info)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off("openUnitSafetyCheckForm")
  }
  public open() {
    this.showDialog = true
  }
  public close() {
    this.showDialog = false
    this.$refs.formData.resetFields()
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
  public fetchData(info: { unitId: number, dataId: number }) {
    this.open()
    this.loading = true
    getInfo(info.dataId).then((response: { data: any }) => {
      this.form = response.data
      this.expandNames = ['base', 'safeCase']
      if (info.dataId === 0) {
        this.form.UnitId = info.unitId
      }
      this.loading = false
    }).catch((error: any) => {
      console.log(error)
    })
  }
  public sendData(data: UnitSafetyCheckData) {
    window.eventBus.$emit("submitUnitSafetyCheckForm", {
      data: data
    })
  }
  public onSubmit() {
    this.$refs.formData.validate((valid: boolean, obj: any) => {
      if (valid) {
        const f = Object.assign({}, this.form)
        const promist = f.Id > 0 ? putData(f.Id, f) : postData(f)
        promist.then((response: { data: any }) => {
          const data = response.data
          const msg = this.form.Id > 0 ? '保存' : '创建'
          if (data && !data.IsError) {
            this.$message({
              message: `${msg}成功`,
              type: 'success'
            })
            this.sendData(f)
            this.close()
          } else {
            this.$message({
              dangerouslyUseHTMLString: true, message: `${data.Message}`,
              type: 'warning'
            })
            console.log(response)
          }
        }, (data: any) => {
          console.log(data)
        })
      }
      else {
        showVaildMsg(this.$message, obj)
      }
    })
  }
}
